import React from 'react';

const Cancellation = {
  title: 'Change and Cancellation policy',
  subTitle: [
    {
      title: 'Trip',
      items: [
        {
          header: 'Change and Cancellation Policy for Local Experts',
          content: (
            <div>
              <p>We recommend that you avoid making changes or cancelling the confirmed booking as it will leave a negative impression and affect trust in the community of Local Experts and TakeMeTour. However, should you need to do so, please contact us as soon as possible.</p>
              Making changes to confirmed trips
              <ul>
                <li><p>Notice has to be given to support@takemetour.com. Please specify the valid reason with solid evidence.</p></li>
                <li><p>After confirming the trip, you can change the trip date only with your traveler’s agreement. It is also subject to availability. Please send the traveler’s agreement to <a href="mailto:support@takemetour.com">support@takemetour.com</a></p></li>
                <li><p>Change of trip and/or Local Expert after confirmation can be arranged only with your traveler’s agreement. It is also subject to availability.</p></li>
                <li><p>If the trip cannot be rescheduled or an agreement cannot be reached, the trip will be considered as canceled. The cancellation policy below will be applied.</p></li>
                <li><p>If you do not show up on the trip day without notice, the trip will consider to be canceled and penalties will apply. </p></li>
              </ul>
              Cancellation of confirmed trips
              <ul>
                <li><p>Notice has to be given to <a href="mailto:support@takemetour.com">support@takemetour.com.</a> Please submit a valid reason with solid evidence.</p></li>
                <li><p>In the event of trip cancellation, TakeMeTour reserves the right to withhold the booking fee and the cost that incurs in the refund process in all cases.</p></li>
                <li><p>Trip cancellation has to be made at least 7 days in advance of the trip day, prior to 12:00AM (Local time GMT+7). As a penalty, the earnings from your next trip/the money in your Wallet will be deducted. The deduction equals 30% of the canceled trip fee.</p></li>
                <li><p>In case of late cancellation (less than 7 days before the trip): as a penalty, the earnings from your next trip/the money in your Wallet will be deducted. The deduction equals 70% of the canceled trip fee.</p></li>
                <li><p>If you have canceled 3 confirmed trips, you will get suspended for 1 year.</p></li>
              </ul>
              <p>Under special circumstances, we may consider cancellation on a case by case basis. Please submit solid reasons and evidence to our support team at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
            </div>
          )
        },
        {
          header: 'What should I do if I need to cancel my trip due to an emergency or unavoidable circumstance? ',
          content: (
            <div>
              <p>Reasons considered extenuating circumstances include:</p>
              <ul>
                <li><p>Unexpected death, fatal injury, or serious illness of a Local Expert or immediate family member (spouse/partner, child, parent, legal guardian, grandparent or sibling)</p></li>
                <li><p>Serious injury that directly restricts a Local Expert’s ability to travel</p></li>
                <li><p>Significant natural disasters or severe weather incidents impacting the location of destination or attraction in the itinerary.</p></li>
                <li><p>Urgent travel restrictions or severe security advisories issued after the time of booking, by an appropriate national or international authority (such a government office or department)</p></li>
                <li><p>Endemic disease declared by a credible nation or international authority (such as the US Centers for Disease Control or the World Health Organization)</p></li>
                <li><p>Government-mandated obligations issued after the time of booking (e.g. jury duty, court appearances, military or government assignments)</p></li>
              </ul>
              <p>If you would like to make a claim for your canceled trip due to extenuating circumstances, please contact <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible. Supporting documents and proofs may be required.</p>
            </div>
          )
        },
        {
          header: 'What is the policy for bad weather?',
          content: (
            <div>
              <p>We suggest you avoid making changes or canceling the confirmed booking as it will leave a negative impression and affect trust in the community of Local Experts and TakeMeTour. If your traveler asks whether they should cancel the trip in case of bad weather, you may follow the steps below:</p>
              <ul>
                <li><p>We suggest you try your best to make your trip possible. You may discuss with your traveler for options, such as rearranging the itinerary or rescheduling the trip.</p></li>
                <li><p>Give the traveler basic information about the weather in Thailand as it has a tropical climate. Please keep in mind that some travelers come from totally different places and may not be well prepared for this kind of weather. It would be very helpful if you could suggest them how and what to prepare.</p></li>
                <li><p>If you have done your best negotiating with the traveler and still cannot come to an agreement, please contact us for assistance at <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible.</p></li>
              </ul>
            </div>
          )
        },
        {
          header: 'What should I do if the traveler cancel my booking?',
          content: (
            <div>
              <p>If you receive a request from the traveler to cancel the confirmed trip, you may ask the traveler to check the change and cancellation policy for booking page and contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> as soon as possible before the trip date.</p>
            </div>
          )
        },
        {
          header: 'How can I help my traveler find a substitute Local Expert?',
          content: (
            <div>
              <p>If you are not available on the requested date, you could click ‘reschedule the trip date’ or cancel the trip. An email asking the traveler for a permission to find a substitute Local Expert will be sent to the traveler’s registered email address. You could also reach us at <a href="mailto:support@takemetour.com">support@takemetour.com</a> for an urgent request as well.</p>
            </div>
          )
        },
        {
          header: 'How do I cancel a trip? ',
          content: (
            <div>
              <p>We recommend that you avoid making changes or canceling the confirmed booking as it will leave a negative impression and affect trust in the community of Local Experts and TakeMeTour. However, should you need to do so, please contact us as soon as possible.</p>
              <p>Please carefully go through the <a href="https://www.takemetour.com/help-center/local-expert?topic=Change%20and%20Cancellation%20policy&subtitle=Trip&index=0">change and cancellation policy for Local Experts</a> page before submitting the <a href="https://supporttmt.typeform.com/to/jMtjRt">cancellation form</a> to us.</p>
            </div>
          )
        }
      ]
    },
  ]
};

export default Cancellation;
